export function setupDetection() {
    const detectionEventName = "CookieBannerDetected";
    const tcfKeyName = "__tcfapi";
    const detectionPoints = [500, 1000, 2000];
    let isSetupComplete = false;
    function hasTCF() {
        return typeof window[tcfKeyName] !== "undefined";
    }
    function setupListener() {
        try {
            if (window[tcfKeyName]) {
                window[tcfKeyName]("addEventListener", 2, handleTCFEvent);
                isSetupComplete = true;
            }
        }
        catch (_) { }
    }
    function handleTCFEvent(tcData, success) {
        if (!success || tcData.eventStatus !== "cmpuishown") {
            return;
        }
        document.dispatchEvent(new CustomEvent(detectionEventName));
        if (window[tcfKeyName]) {
            window[tcfKeyName]("removeEventListener", 2, () => { }, tcData.listenerId);
        }
    }
    function detectCookieBanners() {
        if (!hasTCF()) {
            return;
        }
        setupListener();
    }
    function start() {
        const timerIds = detectionPoints.map((delay) => setTimeout(() => {
            if (isSetupComplete) {
                timerIds.forEach((timerId) => clearTimeout(timerId));
                return;
            }
            detectCookieBanners();
        }, delay));
    }
    start();
}
